export default __webpack_public_path__ + "info-circle.631d617bb2e0c62b.svg";